import React, { Component } from "react";
import { connect } from "react-redux";
import SubjectView from "./components/SubjectView";
import SchoolItem from "../../../components/School/SchoolItem";
import SchoolFilter from "./components/SchoolFilter";
import Loading from "../../../components/Loading";
import ReturnTop from "../../../components/ReturnTop";
import ListErrorPrompt from "../../../components/ListErrorPrompt";
import { post, get } from "../../../utils/request";
import "./style.css";
var finished = true;
/**
 * 选科查询院校的列表组件
 */
class SchoolList extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      data: null,
      dataList: [],
      filterVisible: false,
      dataListVisible: true,
      topVisible: false,
      filterData: null,
      total: null, //存多少条数据
      params: {
        subjectIds: [],
        pageNum: 1,
        pageSize: 20,
      },
    };
    this.removeListener = false;
  }
  componentWillMount() {
    let sessionSubject = JSON.parse(sessionStorage.getItem("suject"));
    let subjectIds;
    // 先看看sessionStorage有没有suject的数据，如果没有去redux里面看看
    if (sessionSubject === null) {
      subjectIds = this.props.subject;
    } else {
      subjectIds = sessionSubject;
    }
    this.setState({
      ...this.state,
      params: {
        ...this.state.params,
        subjectIds: subjectIds,
      },
    });
  }
  render() {
    const { data, dataList, filterVisible, filterData, total } = this.state;
    return (
      <div ref={this.myRef}>
        <SubjectView
          handleVisibleFilter={this.handleVisibleFilter}
          visible={true}
          handleVisibleSearch={this.handleVisibleSearch}
        ></SubjectView>
        {filterData != null ? (
          <SchoolFilter
            visible={filterVisible}
            filterData={filterData}
            handleAddScroll={this.handleAddScroll}
            handleVisibleFilter={this.handleVisibleFilter}
            requestFilterSchoolList={this.requestFilterSchoolList.bind(this)}
            handleChangeParams={this.handleChangeParams.bind(this)}
          ></SchoolFilter>
        ) : (
          ""
        )}
        <div style={{ height: 44 }}></div>
        {total === 0 ? (
          <div>
            <ListErrorPrompt
              imgSrc={require("../../../images/school/notice.png")}
              toptext=""
              bottomtext="什么也没发现，请确保输入正确"
            ></ListErrorPrompt>
          </div>
        ) : (
          ""
        )}
        {data != null ? (
          <div className={this.state.dataListVisible ? "" : "display_none"}>
            {dataList.map((item, index) => {
              return (
                <SchoolItem
                  key={index}
                  item={item}
                  url="/subjectquery/schooldetail/"
                  from="subjectquery/list"
                ></SchoolItem>
              );
            })}
            {this.state.params.pageNum < data.data.pages &&
            data.data.list.length > 10 ? (
              <Loading></Loading>
            ) : (
              <div className="schoolList_shim"></div>
            )}
          </div>
        ) : (
          ""
        )}
        <div className="schoolList_shim"></div>

        <ReturnTop visible={this.state.topVisible}></ReturnTop>
      </div>
    );
  }
  /**
   * 在第一次渲染后调用
   */
  componentDidMount() {
    this.requestSchoolList();
    this.requestSchoolFilter();
    this.handleAddScroll();
    document.title = "浙考之家-万能选科-按选科查";
  }
  componentDidUpdate() {
    setTimeout(() => {
      if (
        this.state.params.pageNum >= this.state.data.data.pages &&
        !this.removeListener
      ) {
        document.removeEventListener("scroll", this.handleScroll);
        this.removeListener = true;
      }
    }, 500);
  }

  componentWillUnmount() {
    if (!this.removeListener) {
      document.removeEventListener("scroll", this.handleScroll);
    }
  }
  /**
   *控制侧边栏条件过滤框的关闭和展示
   */
  handleVisibleFilter = () => {
    this.setState({
      ...this.state,
      filterVisible: !this.state.filterVisible,
    });
  };
  /**
   * 显示列表
   */
  handleShowDataList = () => {
    this.setState({
      dataListVisible: true,
      headerVisible: true,
    });
  };
  /**
   * 院校过滤组件修改院校的请求参数
   */
  handleChangeParams(params) {
    //后续要去掉的方法
    this.setState({
      ...this.state,
      params: {
        ...this.state.params,
        pageNum: params.pageNum,
        pageSize: params.pageSize,
      },
    });
  }
  /**
   * 请求选科条件下的院校列表
   */
  requestSchoolList() {
    let params = {
      subjectIds: this.state.params.subjectIds,
      limits: this.props.schoolFilter.limitFilterId,
      schoolLevelIds: this.props.schoolFilter.levelFilterId,
      schoolTagIds: this.props.schoolFilter.tagFilterId,
      schoolPropertyIds: this.props.schoolFilter.propertyFilterId,
      provinceIds: this.props.schoolFilter.provinceFilterId,
      pageNum: this.state.params.pageNum,
      pageSize: this.state.params.pageSize,
    };
    post("/public/v1/school/subject/list", params).then((data) => {
      const newDataList = this.state.dataList.concat(data.data.list);
      this.setState({
        data: data,
        dataList: newDataList,
        total: newDataList.length,
      });
      finished = true;
    });
  }
  /**
   * 请求院校的过滤条件
   */
  requestSchoolFilter() {
    get("/public/v1/school/filter/1").then((res) => {
      this.setState({
        filterData: res.data,
      });
    });
  }
  /**
   * 在点击侧边栏过滤条件的时候使用
   */
  requestFilterSchoolList() {
    let params = {
      subjectIds: this.state.params.subjectIds,
      limits: this.props.schoolFilter.limitFilterId,
      schoolLevelIds: this.props.schoolFilter.levelFilterId,
      schoolTagIds: this.props.schoolFilter.tagFilterId,
      schoolPropertyIds: this.props.schoolFilter.propertyFilterId,
      provinceIds: this.props.schoolFilter.provinceFilterId,
      pageNum: 1,
      pageSize: 20,
    };
    post("/public/v1/school/subject/list", params).then((data) => {
      const newDataList = data.data.list;
      this.setState({
        data: data,
        dataList: newDataList,
        total: newDataList.length,
      });
      finished = true;
    });
  }
  /**
   * 添加scroll事件监听
   */
  handleAddScroll = () => {
    document.addEventListener("scroll", this.handleScroll);
  };
  // 处理屏幕滚动事件，实现加载更多的效果
  handleScroll = () => {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const screenHeight = document.documentElement.clientHeight;
    const schoolListTop = this.myRef.current.offsetTop;
    const schoolListHeight = this.myRef.current.offsetHeight;
    if (
      finished &&
      scrollTop >= schoolListHeight + schoolListTop - screenHeight - 2
    ) {
      finished = false;
      setTimeout(() => {
        this.setState({
          params: {
            ...this.state.params,
            pageNum: this.state.params.pageNum + 1,
          },
        });
        this.requestSchoolList();
      }, 500);
    }
    if (scrollTop >= 1200) {
      this.setState({
        topVisible: true,
      });
    } else {
      this.setState({
        topVisible: false,
      });
    }
  };
}

const mapStateToProps = (state) => {
  return {
    schoolFilter: state.subject2schoolfilter.schoolFilterData,
    subject: state.subjectquery.subjectData.subject,
  };
};
export default connect(mapStateToProps)(SchoolList);



// WEBPACK FOOTER //
// ./src/containers/SubjectQuerySchool/SchoolList/index.js